export default "__VITE_ASSET__B5BMkI4p__"